<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                             :disabled="sortMode!==0"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="resElectriciansFields" :items="resElectricians"
                     responsive="responsive" :no-local-sorting="true" sort-by="ElectricianName"
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadResElectricians"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadResElectricians"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-show="editMode===1" title="Просмотр записи">
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group v-if="userActionAccessCompany" label="РЭК" label-for="input-edit-company">
                            <b-input id="input-edit-company" v-model="editCompany" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditCompany"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group v-if="userActionAccessRes" label="РЭС" label-for="input-edit-res">
                            <b-input id="input-edit-res" v-model="editRes" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditRes"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Код 1С" label-for="input-edit-is-code">
                            <b-input id="input-edit-is-code" v-model="editIsCode" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditIsCode"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Электромонтер" label-for="input-edit-electrician-name">
                            <b-input id="input-edit-electrician-name" v-model="editElectricianName"
                                     @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description">
                            <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                        readonly="readonly" @keyup.esc="cancelRecord"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Статус записи" label-for="input-edit-record-status">
                            <b-input id="input-edit-record-status" v-model="editRecordStatus" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr/>
                <b-button type="reset" variant="secondary">Закрыть</b-button>
            </b-form>
        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-alert :show="errModal" :variant="errVariantModal" class="mb-4">{{errTextModal}}</b-alert>
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="input-AdvSearch-company">
                        <b-select id="input-AdvSearch-company" :options="searchCompanies"
                                  v-model="searchCompanyUid" autofocus
                                  @change="loadSearchRes"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="userActionAccessRes">
                    <b-form-group label="РЭС" label-for="input-AdvSearch-res">
                        <b-select id="input-AdvSearch-res" :options="searchRes"
                                  v-model="searchResUid"
                                  :disabled="searchCompanyUid===0 && userActionAccessCompany"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Статус записи" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchRecordStatuses"
                                  v-model="searchRecordStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "RESElectricians",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: false,
                userActionAccessRes: false,

                loadProcessing: 0,

                editMode: 0,
                recordUid: "",

                err: false,
                errText: "",
                errVariant: "danger",

                errModal: false,
                errTextModal: "",
                errVariantModal: "danger",

                searchQuickFilter: "",
                searchRecordStatus: -1,
                searchCompanyUid: 0,
                searchResUid: "",

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "ElectricianName",
                sortDesc: false,

                searchRecordStatuses: [
                    {'value': -1, 'text': "<все>"},
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],
                searchCompanies: [],
                searchRes: [{'value': '', 'text': '<все>'}],

                resElectricians: [],
                resElectriciansFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "RES", label: "РЭС", sortable: true, tdClass: "pointer"},
                    {key: "ElectricianName", label: "Электромонтер", sortable: true, tdClass: "pointer"},
                    {key: "RecordStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],

                editCompany: "",
                editRes: "",
                editIsCode: "",
                editElectricianName: "",
                editDescription: "",
                editRecordStatus: "",
            }
        },
        created() {
            this.userActionAccessArray = this.getUserActionAccessArray("RefsRESElectricians", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
            this.userActionAccessRes = this.getUserDataAccess("RefsRES", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Справочники", route: "res-electricians"},
                {title: "Электромонтеры ПУ"}
            ]);

            if (this.userData.UserGroupUid === 1) this.loadCompanies()
            this.loadResElectricians()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.resElectriciansFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.resElectriciansFields.splice(ind, 1)
            }
            //If no access to Res - delete Res from the list
            if (!this.userActionAccessRes) {
                let ind = this.resElectriciansFields.findIndex(item => item.key.toLowerCase() === "res");
                if (ind >= 0)
                    this.resElectriciansFields.splice(ind, 1)
            }

            //If no access to archive
            if (!this.userActionAccessArray['archive']) {
                let ind = this.searchRecordStatuses.findIndex(item => item.value === 4);
                if (ind >= 0)
                    this.searchRecordStatuses.splice(ind, 1)
            }

            this.loadSearchRes()

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            errTextHideModal() {
                this.errModal = false
                this.errTextModal = ""
            },
            errTextShowModal(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errTextModal = msg
                this.errVariantModal = variant
                this.errModal = true
            },
            loadCompanies() {
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSearchRes() {
                this.searchResUid = ""
                this.searchRes = [{'value': "", 'text': '<все>'}]
                this.errTextHideModal()

                if (!this.userActionAccessRes) return

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadResElectricians() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESElectricians", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RES_UID': this.searchResUid,
                        'F_ElectricianName': this.searchQuickFilter,
                        'F_RS': this.searchRecordStatus,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.resElectricians = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.resElectricians = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            tableRowClicked(item) {
                this.errTextHide()
                this.recordUid = item.UID
                this.editCompany = ""
                this.editRes = ""
                this.editIsCode = ""
                this.editElectricianName = ""
                this.editDescription = ""
                this.editRecordStatus = ""

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESElectrician", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompany = !this.isUndefined(result.CompanyAlias) ? result.CompanyAlias : ""
                                    this.editRes = !this.isUndefined(result.RES) ? result.RES : ""
                                    this.editIsCode = result.ISCode.toString()
                                    this.editElectricianName = result.ElectricianName.toString()
                                    this.editDescription = result.Description.toString()
                                    this.editRecordStatus = result.RecordStatus.toString()
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--
                        if (this.userActionAccessCompany) {
                            this.$nextTick(() => {
                                this.$refs.inputEditCompany.$el.focus()
                            })
                        } else if (this.userActionAccessRes) {
                            this.$nextTick(() => {
                                this.$refs.inputEditRes.$el.focus()
                            })
                        } else {
                            this.$nextTick(() => {
                                this.$refs.inputEditIsCode.$el.focus()
                            })
                        }
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            cancelRecord() {
                this.errTextHide()
                this.editMode = 0
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadResElectricians()
            },
            buttonSearchClicked() {
                this.recordCurrentPageNumber = 1
                this.loadResElectricians()
            },
            buttonAdvSearchShowClicked() {
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                if (this.searchCompanyUid !== 0 || this.searchResUid !== "" || this.searchRecordStatus !== -1) {
                    this.sortMode = 1
                    this.searchQuickFilter = ""
                } else {
                    this.sortMode = 0
                }

                this.recordCurrentPageNumber = 1

                this.loadResElectricians()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchResUid = ""
                this.searchRecordStatus = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadResElectricians()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            },
            buttonRefreshClicked() {
                this.loadResElectricians()
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>

</style>